// extracted by mini-css-extract-plugin
module.exports = {"pointer":"pointer_1zWMq","icon":"icon_2_0Ro","iconDescription":"iconDescription_292Ns"};